import { apiClient } from "@apis/apiClient";
import type {
  ApiResponse,
  LogErrorParams,
  LogErrorCspParams,
} from "./errorBoundaryClient.dto";

/**
 * Error Boundary API Client
 *
 * Provides methods for logging errors and CSP violations.
 */
const errorBoundaryClient = {
  /**
   * Log an error to the error boundary endpoint
   * @param params - Error parameters to log
   * @returns API response
   */
  logError(params: LogErrorParams): Promise<ApiResponse<unknown>> {
    return apiClient.post(`/rest/error_boundary`, params);
  },

  /**
   * Log a Content Security Policy (CSP) violation
   * @param params - CSP error parameters to log
   * @returns API response
   */
  logErrorCsp(params: LogErrorCspParams): Promise<ApiResponse<unknown>> {
    return apiClient.post(`/rest/csp_report`, params);
  },
};

export { errorBoundaryClient };
export default errorBoundaryClient;
